module.exports = __webpack_public_path__ + "static/media/ic_proyectos_maritimo_pin.98f1218c.svg";